import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-2 w-full overflow-y-auto h-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SectionSelectDestCargoType = _resolveComponent("SectionSelectDestCargoType")!
  const _component_CargoDisputeForm = _resolveComponent("CargoDisputeForm")!
  const _component_CargoV2ManualInput = _resolveComponent("CargoV2ManualInput")!
  const _component_ScanTableSection = _resolveComponent("ScanTableSection")!
  const _component_CreateCargoNonRtcLayout = _resolveComponent("CreateCargoNonRtcLayout")!

  return (_openBlock(), _createBlock(_component_CreateCargoNonRtcLayout, {
    isShowSearchFlightBtn: _ctx.form.cargoType.value === 'plane',
    isDisabledSearchFlightBtn: !_ctx.isValidSearchFlight,
    onSearchFlight: _ctx.onProcessSearchFlight,
    isDisabledBookingBtn: !_ctx.isValidBooking,
    onBooking: _ctx.onProcessBooking
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_SectionSelectDestCargoType),
        _createVNode(_component_CargoDisputeForm),
        _createVNode(_component_CargoV2ManualInput),
        _createVNode(_component_ScanTableSection, { key: _ctx.keySuccess })
      ])
    ]),
    _: 1
  }, 8, ["isShowSearchFlightBtn", "isDisabledSearchFlightBtn", "onSearchFlight", "isDisabledBookingBtn", "onBooking"]))
}